import { Box, Grid, Skeleton, SxProps, Theme } from '@mui/material';
import React from 'react'

export const BannerSkeleton = () => (
    <Skeleton
        variant="rectangular"
        width="100%"
        animation='wave'
        height={600}
        sx={{ borderRadius: "12px" }}
    />
);
type ResponsiveValue =
    | string
    | number
    | {
        xs?: string | number;
        sm?: string | number;
        md?: string | number;
        lg?: string | number;
        xl?: string | number;
    };

interface ShimmerProps {
    width?: ResponsiveValue;
    height?: ResponsiveValue;
    borderRadius?: ResponsiveValue;
}

export const Shimmer = ({
    width = "100%",
    height = "100%",
    borderRadius = 2,
}: ShimmerProps) => {
    return (
        <Box
            className="shimmer"
            sx={{
                width,
                height,
                borderRadius,
            }}
        />
    );
};

export const ProductSliderSkeleton = () => (
    <Grid container spacing={2}>
        {[...Array(5)].map((_, index) => (
            <Grid key={index} size={{ xs: 6, md: 3, lg: 2.4 }}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    animation='wave'
                    height={280}
                    sx={{ borderRadius: "12px" }}
                />
                <Skeleton width="80%" sx={{ mt: 1 }} />
                <Skeleton width="50%" />
            </Grid>
        ))}
    </Grid>
);

export const CategorySkeleton = () => (
    <Grid container spacing={3}>
        {[...Array(6)].map((_, index) => (
            <Grid
                key={index}
                size={{ xs: 4, md: 3, lg: 2 }}
                className="d-flex flex-column align-items-center"
            >
                <Skeleton
                    variant="circular"
                    width={120}
                    animation='wave'
                    height={120}
                />
                <Skeleton width={80} sx={{ mt: 1 }} />
                <Skeleton width={60} />
            </Grid>
        ))}
    </Grid>
);

export const BrandSkeleton = () => (
    <Grid className='justify-content-center' container spacing={2}>
        {[...Array(7)].map((_, index) => (
            <Grid key={index} size={{ xs: 4, lg: "auto" }}>
                <Skeleton
                    variant="rectangular"
                    width={180}
                    animation='wave'
                    height={180}
                    sx={{ borderRadius: "12px" }}
                />
            </Grid>
        ))}
    </Grid>
);
